import { render } from "./SessionTimer.vue?vue&type=template&id=d837f2f4&scoped=true&ts=true&lang=pug"
import script from "./SessionTimer.vue?vue&type=script&lang=ts"
export * from "./SessionTimer.vue?vue&type=script&lang=ts"

import "./SessionTimer.vue?vue&type=style&index=0&id=d837f2f4&lang=scss&scoped=true"
/* custom blocks */
import block0 from "./SessionTimer.vue?vue&type=custom&index=0&blockType=i18n&locale=en"
if (typeof block0 === 'function') block0(script)
import block1 from "@/locale/es/components/sessionTimer.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Ftarball%2Fsrc%2Fcomponents%2FSessionTimer.vue&locale=es"
if (typeof block1 === 'function') block1(script)


import exportComponent from "/tarball/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d837f2f4"]])

export default __exports__